import { useContext } from 'react';

import { TabStateContext } from './TabStateContext';

export const useTabStateContext = () => {
  const context = useContext(TabStateContext);
  if (!context) {
    throw new Error('useTabStateContext must be used within a TabStateProvider');
  }
  return context;
};
